// // advanced search
// // stores inputGroups and build/parse adv search query string

class AdvancedSearch {
  static instance = null;

  constructor(fields) {
    if (!AdvancedSearch.instance) {
      this.fields = [];
      this.fieldOpts = [];
      this.nestedFields = [];
      this.inputGroups = [
        {
          bool: 'AND',
          q: '',
          field: 'any'
        },
        {
          bool: 'AND',
          q: '',
          field: 'any'
        }
      ];
      this.boolOpts = ['AND', 'OR', 'NOT'];
      this.initFields(fields);
      AdvancedSearch.instance = this;
    }
    return AdvancedSearch.instance;
  }

  initFields = (fields) => {
    for (let f in fields) {
      let nestedField = '';

      if (!f.includes('internal') && fields[f]) {
        this.fields.push({
          label: fields[f],
          value: f
        });

        if (f.includes('.')) {
          nestedField = f.split('.')[0];
          if (!this.nestedFields.includes(nestedField)) {
            this.nestedFields.push(nestedField);
          }
        }
      }
    }
    this.fieldOpts = [
      {
        label: 'Any field',
        value: 'any'
      },
      ...this.fields
    ];
  }

  addInputGroup = () => {
    this.inputGroups.push({
      bool: 'AND',
      q: '',
      field: 'any'
    });
  }

  removeInputGroup = (idx) => {
    this.inputGroups.splice(idx, 1);
  }

  updateInputGroup = (group) => {
    Object.assign(this.inputGroups[group.idx], group.inputGroup);
  }

  makeQueryString = (advSearchArray = this.inputGroups) => {
    let queryString = '';

    for (let i in advSearchArray) {
      let fieldName = advSearchArray[i].field.split('.')[0];
      let queryTerm = '';

      if (advSearchArray[i].q) {
        if (!this.isBasicSearch()) {
          advSearchArray[i].q = this.escapeSpecialChars(advSearchArray[i].q);
        }

        if (advSearchArray[i].field !== 'any') {
          if (this.nestedFields.includes(fieldName)) {
            let nestedFieldName = this.getSearchFieldFromNestedField(advSearchArray[i].field);
            queryTerm = `${nestedFieldName}: (${advSearchArray[i].q})`;
          } else {
            queryTerm = `${advSearchArray[i].field}: (${advSearchArray[i].q})`;
          }
        } else {
          queryTerm = advSearchArray[i].q;
        }

        queryString = (i === '0') ? queryString + queryTerm : queryString + ' ' + advSearchArray[i].bool + ' ' + queryTerm;
      }
    }
    return queryString;
  }

  parseQueryString = (str) => {
    let bools = / AND | OR | NOT /g;
    let boolValues = str.match(bools);
    let inputValues = str.split(bools);

    this.inputGroups = [];

    for (let i in inputValues) {
      let bool = (i === '0') ? 'AND' : boolValues[i - 1].trim();
      let field = '', value = '';

      field = this.getField(inputValues[i]);

      if (this.nestedFields.includes(field.split('.')[0])) {
        let searchField = this.getSearchFieldFromNestedField(field);
        value = (inputValues[i].includes(`${searchField}: `)) ? inputValues[i].replace(`${searchField}: `, '') : inputValues[i];
      } else {
        value = (inputValues[i].includes(`${field}: `)) ? inputValues[i].replace(`${field}: `, '') : inputValues[i];
      }

      if (value.slice(0, 1) === '(' && value.slice(-1) === ')') {
        value = value.slice(1, value.length);
      }

      let inputGroup = {
        bool,
        q: value,
        field
      };
      this.inputGroups.push(inputGroup);
    }
    return this.inputGroups;

  }

  escapeSpecialChars(queryString) {
    let escapeCharacters = ['+', '-', '!', '(', ')', '{', '}', '[', ']', '^', '~', '*', '?', ':', '/'];

    for (let character of escapeCharacters) {
      let regex = RegExp('\\' + character + '|\\\\\\' + character);
      queryString = queryString.replace(regex, '\\' + character);
    }

    return queryString;
  }

  isBasicSearch() {
    let isBasic = false;
    let validInputGroups = this.inputGroups.filter(inputGroup => inputGroup.q.length !== 0);

    if (validInputGroups.length === 1 && validInputGroups[0].field === 'any' && !(validInputGroups[0].q.charAt(0) === '"' && validInputGroups[0].q.substr(-1) === '"')) {
      isBasic = true;
    }

    return isBasic;
  }

  getField(str) {
    let field = 'any';

    for (let advSearchField of this.fields) {
      let advSearchFieldValue = this.getSearchFieldFromNestedField(advSearchField.value);
      let term = `${advSearchFieldValue}: `;

      if (str.includes(term)) {
        return advSearchField.value;
      }
    }

    return field;
  }

  getSearchFieldFromNestedField(str) {
    return str.replace('.', '_');
  }

  getNestedFieldFromSearchField(str) {
    return str.replace('_', '.');
  }
}

export default AdvancedSearch;